import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {InterfaceEventsEnum, trackInterfaceEvent} from '../../../services/tracking';
import {addViewingNowCalendarVersionForAddressAction} from '../../../store/panels/calendars/calendarsPanelActions';
import {CalendarsPanelId} from '../../../store/panels/panelStateBase';
import {FindCalendarDropdownBox} from './findCalendarDropdownBox';

/*
 * Props.
 */

interface FindCalendarDropdownBoxContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<FindCalendarDropdownBoxContainerProps>()(({panelId}) => ({
  onAddressSelect: (address: string) => {
    trackInterfaceEvent(InterfaceEventsEnum.SEARCH_FOR_CALENDAR);
    return addViewingNowCalendarVersionForAddressAction(panelId, address);
  },
}));

export const FindCalendarDropdownBoxContainer = connect(null, mapDispatchToProps)(FindCalendarDropdownBox);
